import { Badge } from "@fox1ck-org/ui";
import { Building2, Layers, Users } from "lucide-react";
import type { OrgUnitType } from "@/types/org";

const config: Record<OrgUnitType, { icon: React.ComponentType<{ className?: string }>; label: string; className: string }> = {
  company: { icon: Building2, label: "Компания", className: "bg-blue-500/10 text-blue-400 border-blue-500/20" },
  department: { icon: Layers, label: "Отдел", className: "bg-purple-500/10 text-purple-400 border-purple-500/20" },
  team: { icon: Users, label: "Команда", className: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" },
};

export function OrgUnitTypeBadge({ type }: { type: OrgUnitType }) {
  const c = config[type] ?? config.team;
  const Icon = c.icon;
  return (
    <Badge variant="outline" className={c.className}>
      <Icon className="h-3 w-3 mr-1" />
      {c.label}
    </Badge>
  );
}
